import { META_PIXEL_ID } from '../data/content';

type FbqStub = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: FbqStub;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: FbqStub;
    _fbq?: FbqStub;
  }
}

let initialized = false;

export function initMetaPixel() {
  if (typeof window === 'undefined' || initialized || !META_PIXEL_ID) return;
  initialized = true;

  if (!window.fbq) {
    const stub = function (...args: unknown[]) {
      if (stub.callMethod) stub.callMethod(...args);
      else stub.queue.push(args);
    } as FbqStub;
    stub.push = stub;
    stub.loaded = true;
    stub.version = '2.0';
    stub.queue = [];
    window.fbq = stub;
    if (!window._fbq) window._fbq = stub;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq?.('init', META_PIXEL_ID);
  window.fbq?.('track', 'PageView');
}

export function trackPixel(event: 'InitiateCheckout' | 'ViewContent') {
  if (typeof window === 'undefined') return;
  window.fbq?.('track', event);
}
